module.exports = __webpack_public_path__ + "img/footer_max_bg.1637f7c3.png";